<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refOutputList'
        :data-source='outputList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "false"
        :height='gridHeight' :row-alternation-enabled="true"
        :auto-navigate-to-focused-row="false"
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared="onCellPrepared"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="판매가"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
         :group-index="0"
          :allowEditing='true'
          caption="고객사"
          data-field="입고업체"
          :visible='true'
          :fixed="true"
          :min-width='100'
        >
          <DxLookup
            :data-source="firstVendorInfoLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="차종"
          data-field="차종"
          :visible='true'
          width='50'
          :fixed="true"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          :visible='true'
          width='100'
          :fixed="true"
        >
        </DxColumn>
        <DxColumn v-for='(item, i)  in daily' :key="i"
          alignment="center"
          :caption="item.split('-')[2]+'일'"
        >
          <DxColumn
            alignment="right"
            caption="실적"
            :data-field="item+' 출하'"
            :min-width="40"
            >
          </DxColumn>
          <DxColumn
            alignment="right"
            caption="엑셀"
            :data-field="item+' 엑셀'"
            :min-width="40"
            >
          </DxColumn>
          <!-- <DxColumn
            alignment="right"
            caption="차이"
            :visible="false"
            :data-field="item+' 차이'"
            :min-width="40"
            >
          </DxColumn> -->
        </DxColumn>
        <DxGrouping :auto-expand-all="autoExpandAll"/>
        <DxSummary>
          <DxGroupItem
            column="품번"
            summary-type="count"
            display-format="{0} 건"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="매출수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="매출금액"
            display-format="{0} (원)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
      <input id="excel-file-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
      <input id="excel-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxGroupItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup, DxGrouping } from 'devextreme-vue/data-grid'
import ExcelJS from 'exceljs'
import AppLib from '../../share/AppLib'

export default {
  name: 'Check',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '출하비교'
        }
      ],
      outputList: [],
      daily: [],
      caption: ['출하', '엑셀'],
      firstVendorInfoLookup: null,
      autoExpandAll: true,
      searchDate: null,
      cellElements: []
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxGroupItem,
    DxGrouping
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.searchDate = AppLib.getNow().substring(0, 7)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
    this.firstVendorInfoLookup = this.$store.getters.getFirstVendor
    this.refreshList()
    this.makeDaily()
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcQty () {
      this.outputList.forEach(data => {
        this.daily.forEach(day => {
          if (data[day + ' 출하'] !== undefined || data[day + ' 엑셀'] !== undefined) {
            if (data[day + ' 출하'] !== data[day + ' 엑셀']) {
              data[day + ' 차이'] = true
            }
          }
        })
      })
    },
    onCellPrepared (e) {
      if (e.rowType === 'data') {
        if (e.column.caption === '실적') {
          e.cellElement.style.backgroundColor = '#e8e8ff'
        }
        if (e.columnIndex > 2 && e.columnIndex % 2 === 1) {
          let key = e.column.dataField
          if (e.data[key] !== e.data[`${key.substring(0, 10)} 엑셀`]) {
            e.cellElement.style.color = '#ff7970'
          }
        } else if (e.columnIndex > 2 && e.columnIndex % 2 === 0) {
          let key = e.column.dataField
          if (e.data[key] !== e.data[`${key.substring(0, 10)} 출하`]) {
            e.cellElement.style.color = '#ff7970'
          }
        }
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>기준월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.searchDate,
            type: 'date',
            acceptCustomValue: false,
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            max: `${AppLib.calcMonthFromToday(0).substring(0, 7)}`,
            dateSerializationFormat: 'yyyy-MM',
            displayFormat: 'yyyy-MM',
            onValueChanged: (args) => {
              this.searchDate = args.value
              this.makeDaily()
              this.refreshList()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.autoExpandAll,
            text: '열기',
            onValueChanged: (args) => {
              this.autoExpandAll = args.value
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'file',
            text: '파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#excel-file-input').click()
            }
          }
        }
      )
    },
    onDetailFileChange ($event) {
      this.isLoading = true
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let vm = this
      let file = document.getElementById('excel-file-input')['files'][0]
      this.$Q('#excel-file-input').val('')
      let reader = new FileReader()

      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(async function (workbook) {
          await workbook.eachSheet(function (worksheet, sheetId) {
            vm.saveExcelRead(worksheet, worksheet.name)
          })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    saveExcelRead (worksheet, company) {
      let row = null
      let value = null
      let emptyRow = 0
      // let tempArray = []
      for (let i = 8; i < 3000; i++) {
        let dataJson = {}
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, 2)
        if (value === null) {
          if (emptyRow === 0) {
            emptyRow++
            continue
          } else {
            console.log(`${company}  read row=${i - 9}`)
            break
          }
        }
        emptyRow = 0
        const monthTotal = AppLib.getCellFromExcel(row, 8)
        if (monthTotal === 'undefined') continue
        dataJson.입고업체 = this.$_.findWhere(this.firstVendorInfoLookup, { 거래처명: company }).거래처코드
        dataJson.차종 = AppLib.getCellFromExcel(row, 2)
        dataJson.품번 = AppLib.getCellFromExcel(row, 4)

        let toMonthDay = AppLib.getMonthLastDay(this.searchDate.split('-')[0], this.searchDate.split('-')[1])
        for (let j = 1; j <= toMonthDay; j++) {
          let qty = AppLib.getCellFromExcel(row, 14 + j)
          let day = `${this.searchDate}-` + ('00' + j.toString()).slice(-2)
          if (qty > 0) dataJson[day + ' 엑셀'] = qty
        }
        let where = this.$_.findWhere(this.outputList, { 품번: dataJson.품번 })
        if (where !== null && where !== undefined) {
          Object.assign(where, dataJson)
        } else {
          this.outputList.push(dataJson)
        }
      }
      // this.calcQty()
      this.$refs.refOutputList.instance.refresh()
      this.isLoading = false
    },
    refreshList () {
      this.isLoading = true
      this.outputList = []
      let date = this.searchDate.split('-')
      this.baseDate = {
        fromDate: `${this.searchDate}-01`,
        toDate: `${this.searchDate}-${AppLib.getMonthLastDay(date[0], date[1])} 23:59:59`
      }
      this.$_sp.runNoEncodeFindProc('spFindAllOutProductByDate', this.baseDate)
        .then(async (data) => {
          const outputList = this.$_sp.MakeModel(data)
          await this.makePivotData(outputList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    makePivotData (dataList) {
      const gByItem = this.$_.groupBy(dataList, function (list) { return list.품번 })
      const gByDate = this.$_.groupBy(dataList, function (list) { return list.발생일자 })
      const itemArray = Object.keys(gByItem)
      const dateArray = Object.keys(gByDate)

      for (let i = 0; i < itemArray.length; i++) {
        let obj = {}
        obj.품번 = itemArray[i]
        for (let j = 0; j < dateArray.length; j++) {
          let where = this.$_.findWhere(dataList, { 품번: itemArray[i], 발생일자: dateArray[j] })
          if (where !== undefined) {
            obj['차종'] = where.차종
            obj['입고업체'] = where.입고업체
            obj[dateArray[j] + ` 출하`] = `${where.수량}`
          }
        }
        this.outputList.push(obj)
      }
    },
    makeDaily () {
      this.daily = []
      let toMonthDay = AppLib.getMonthLastDay(this.searchDate.split('-')[0], this.searchDate.split('-')[1])
      for (let j = 1; j <= toMonthDay; j++) {
        this.daily.push(`${this.searchDate}-` + ('00' + j.toString()).slice(-2))
      }
    }
  }
}
</script>

<style lang="scss">

</style>
